import React, { useState } from 'react'
import ArticleShort from '../components/shared/ArticleShort'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import ProfileShort from '../components/shared/ProfileShort'
import { useQuery } from '@tanstack/react-query'
import { fetchUserPublicInfo } from '../utils/services/fetchUser'
import { fetchSomeoneStuff } from '../utils/services/fetchThing'
import { fetchDatabase } from '../utils/services/fetchDatabase'
import Pagination from '../components/Dashboard/Pagination'
import { fetchUserInfo } from '../utils/services/fetchUser'
import Sidebar from '../components/shared/Sidebar'

const StyledPublicProfile = styled.div`
    display: flex;
`
const StyledPagination = styled(Pagination)``
const StyledListOfSellerStuff = styled.div`
    display: flex;
    flex-direction: column;
    margin: 20px;
`

const PublicProfile = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false)
    const { userNumber } = useParams()
    const [currentPage, setCurrentPage] = useState(1)

    // Get user info
    const { data: userInfo } = useQuery({
        queryKey: ['userInfo'],
        queryFn: fetchUserInfo,
        staleTime: 5 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching user info:', err)
        },
    })

    // Get seller public info, only if thingInfo is available
    const {
        data: sellerInfo,
        isLoading: isLoadingSeller,
        isError: isErrorSeller,
    } = useQuery({
        queryKey: ['sellerInfo', userNumber],
        queryFn: () => fetchUserPublicInfo(userNumber),
        staleTime: 5 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching seller info:', err)
        },
    })

    // Get seller public info, only if thingInfo is available
    const {
        data: sellerStuff,
        isLoading: isLoadingStuff,
        isError: isErrorStuff,
    } = useQuery({
        queryKey: ['sellerStuff', userNumber],
        queryFn: () => fetchSomeoneStuff(userNumber),
        staleTime: 5 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching seller info:', err)
        },
    })

    // get the database of the stuff categories
    const {
        data: stuffCategories,
        isLoading: isLoadingStuffCategories,
        isError: isErrorStuffCategories,
    } = useQuery({
        queryKey: ['categoryDatabase'],
        queryFn: fetchDatabase,
        staleTime: 60 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching stuff categories:', err)
        },
    })

    // Handle loading states
    if (isLoadingSeller || isLoadingStuff || isLoadingStuffCategories) {
        return <div>Loading...</div>
    }

    if (isErrorSeller || isErrorStuff || isErrorStuffCategories) {
        return <div>Error fetching seller information.</div>
    }

    return (
        <StyledPublicProfile>
            {userInfo && (
                <Sidebar
                    setIsSidebarOpen={setIsSidebarOpen}
                    isSidebarOpen={isSidebarOpen}
                    userInfo={userInfo}
                />
            )}{' '}
            <ProfileShort userInfo={userInfo} sellerInfo={sellerInfo} />
            <StyledListOfSellerStuff>
                {sellerStuff.results.length > 0
                    ? sellerStuff.results?.map((item) => (
                          <ArticleShort
                              key={item._id}
                              sellOrBuySection={'buy'}
                              stuffCategories={stuffCategories}
                              item={item}
                          />
                      ))
                    : "Cette personne n'a pas d'objets à vendre pour le moment."}
                {sellerStuff.results?.length > 8 && (
                    <StyledPagination
                        currentPage={sellerStuff.currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={sellerStuff.totalPages}
                    />
                )}
            </StyledListOfSellerStuff>
        </StyledPublicProfile>
    )
}

export default PublicProfile
